import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import CalenderEventsFull from './calender-events-full';

const CalenderEventsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <CalenderEventsFull {...props} />
    </QueryClientProvider>
  );
};

export { CalenderEventsFullWidget }
